import { Dismiss12Regular } from '@fluentui/react-icons';
import React from 'react';
import { useTranslation } from 'react-i18next';
import './ChatParticipantChip.scss';

interface ChatParticipantChipProps {
  displayName: string;
  onRemoveClick?: () => void;
}

export const ChatParticipantChip: React.FC<ChatParticipantChipProps> = ({
  displayName,
  onRemoveClick,
}) => {
  const { t } = useTranslation();

  return (
    <span className="ChatParticipantChip">
      <span className="chipName">{displayName}</span>
      {onRemoveClick && (
        <button
          className="chipDismiss"
          onClick={onRemoveClick}
          aria-label={t('pc:chat:participantPicker:remove_person_aria', {
            defaultValue: '{{name}} entfernen',
            name: displayName,
          })}
        >
          <Dismiss12Regular />
        </button>
      )}
    </span>
  );
};
